import moment from 'moment';
import { request } from '../../requests';
export default {
  namespaced: true,
  state: {
    details: {
      result: {},
      loading: false,
      timestamp: null
    },
    errors: {}
  },
  actions: {
    fetchProfile({
      commit
    }, {
      projectID
    }) {
      const url = `/tables/projects/${projectID}/profile`;
      const method = 'GET';
      commit('setProfileLoading', true);
      return request({
        url,
        method
      }).done(responseData => {
        commit('setProfileDetails', responseData.result);
        commit('setProfileTimestamp', moment());
      }).always(() => {
        commit('setProfileLoading', false);
      });
    },
    updateLink({
      commit
    }, {
      projectID,
      form
    }) {
      const url = `/forms/profile/${projectID}/link`;
      const data = {
        ...form
      };
      return request({
        url,
        data
      });
    },
    taskDone(context, [task, done]) {
      const url = `/forms/tasks/${task.id}/done`;
      const data = JSON.stringify({
        done
      });
      return jQuery.ajax({
        contentType: 'application/json',
        dataType: 'json',
        type: 'POST',
        data,
        url
      });
    },
    submitBackground({
      commit
    }, {
      projectID,
      color
    }) {
      const url = `/forms/profile/${projectID}/background`;
      const data = {
        color
      };
      const method = 'POST';
      return request({
        url,
        data,
        method
      });
    }
  },
  getters: {
    manager(state) {
      return state.details.result.manager;
    },
    profile(state) {
      return state.details.result.profile;
    },
    project(state) {
      return state.details.result.project;
    },
    loading(state) {
      return state.details.loading;
    },
    errors(state) {
      return state.errors;
    }
  },
  mutations: {
    setProjectLink(state, link) {
      const project = state.details.result.project;
      if (project) {
        project.makeup_day_link = link;
      }
    },
    setProfileLogo(state, url) {
      const profile = state.details.result.profile;
      if (profile) {
        profile.logo = url;
      }
    },
    setProfileDetails(state, result) {
      return state.details.result = result;
    },
    setProfileLoading(state, loading) {
      return state.details.loading = loading;
    },
    setProfileTimestamp(state, timestamp) {
      return state.details.timestamp = timestamp;
    },
    details(state, obj) {
      return state.details = obj;
    },
    errors(state, obj) {
      return state.errors = obj;
    }
  }
};